import React, { Component } from "react";
import webSocketClient from "../socket/socket";
import { HiOutlineX, HiOutlineMenu } from 'react-icons/hi';
import { HiOutlineUserCircle } from 'react-icons/hi';

import {
    WidgetHeaderContainer,
    WidgetHeaderBox,
    WidgetHeader,
    WidgetHeaderController,
    ControllerBtnIconLarge,
    ControllerBtnIcon,
} from "../component/Component.Header";


import loadable from '@loadable/component'
const WidgetNavigator = loadable(() => import('./widget.navigator'));
WidgetNavigator.preload();

const WidgetAccount = loadable(() => import('./widget.account'));
WidgetAccount.preload();


class Header extends Component{
    constructor(props){
        super(props);

        this.socketClient                   = webSocketClient();
        this.funcNavigatePage               = this.props.funcNavigatePage;

        this.funcLoggedOut                  = typeof this.props.funcLoggedOut === 'function'?this.props.funcLoggedOut:undefined;

        this.state  = {
            isLoggedIn: props.isLoggedIn,
            isLeftControllerShow: false,
            isRightControllerShow: true,
            fullname: '',
            username: '',
            level: '',
            position: '',
            company: '',
            
            join_date: '',
            user_profile: '',

            company_name: '',
            menu: [],
        }

        this.handleLeftController           = this.handleLeftController.bind(this);
        this.handleRightController          = this.handleRightController.bind(this);

        this.handleMenuController           = this.handleMenuController.bind(this);
    }
// ==================================================================================
// COMPONENT DID MOUNT
// ==================================================================================
    componentDidMount(){
        this.socketClient.onEvent("UserLoggedIn", (event) => {
            if(!event.hasOwnProperty("username")){
                //console.log('UserLoggedIn', event);
                this.setState({
                    ...this.state,
                    isLoggedIn: true,
                    username: event.login_name,
                    level: event.level,
                    position: event.position,
                    fullname: event.fullname,
                    company: event.company_name,

                    isLeftControllerShow: false,
                    isRightControllerShow: false,
                });
            }
        });
        this.socketClient.onEvent("GetMenu", (event) => {
            if (!event.hasOwnProperty("username")){
                //console.log('GetMenu', event);
                this.setState({
                    ...this.state,
                    menu: event.menu,
                    isLeftControllerShow: false,
                    isRightControllerShow: false,
                });
            }
        });
        this.socketClient.onEvent("MyAccountUpdate", (event) => {
            if (!event.hasOwnProperty("username")){
                this.setState({
                    fullname: event.full_name,
                    username: event.user_name,
                    level: event.user_level,
                    company: event.company_name,
                });
            }
        });
        this.socketClient.onDisconnected(() => {
            this.setState({
                ...this.state,
                isLoggedIn: false,
                fullname: '',
                username: '',
                level: '',
                company: '',

                //position: '',
                //join_date: '',
                menu: [],

                isLeftControllerShow: false,
                isRightControllerShow: true,
            });
        });
    }
// ==================================================================================
// COMPONENT MANAGEMENT
// ==================================================================================
    handleLeftController(e){
        e.preventDefault();
        if (this.state.isLeftControllerShow){
            this.setState({
                ...this.state,
                isLeftControllerShow: false,
            })
        } else {
            this.setState({
                ...this.state,
                isLeftControllerShow: true,
                isRightControllerShow: false,
            });
        }
    }

    handleRightController(e) {
        e.preventDefault();
        if (this.state.isRightControllerShow){
            this.setState({
                ...this.state,
                isRightControllerShow: false,
            });
        } else {
            this.setState({
                ...this.state,
                isRightControllerShow: true,
                isLeftControllerShow: false,
            });
        }
    }

    handleMenuController() {
        if (this.state.isLeftControllerShow){
            this.setState({
                ...this.state,
                isLeftControllerShow: false,
            })
        } else {
            this.setState({
                ...this.state,
                isLeftControllerShow: true,
                isRightControllerShow: false,
            })
        }
    }
// ==================================================================================
// FUNGSI-FUNGSI
// ==================================================================================

// ==================================================================================
// RENDER
// ==================================================================================
    render(){
        if (this.state.isLoggedIn) {
            return (
                <WidgetHeaderContainer>
                    <WidgetHeaderBox>
                        <WidgetHeader IsLeft>
                            <WidgetHeaderController onClick={(e) => {this.handleLeftController(e)}}>
                                {this.state.isLeftControllerShow?
                                <>
                                    <ControllerBtnIcon><HiOutlineX size={28} /></ControllerBtnIcon>
                                    <ControllerBtnIconLarge><HiOutlineX size={33} /></ControllerBtnIconLarge>
                                </>
                                :
                                <>
                                    <ControllerBtnIcon><HiOutlineMenu size={28} /></ControllerBtnIcon>
                                    <ControllerBtnIconLarge><HiOutlineMenu size={33} /></ControllerBtnIconLarge>
                                </>
                                }
                            </WidgetHeaderController>
                        </WidgetHeader>
                        <WidgetHeader>
                            <WidgetHeaderController onClick={(e) => {this.handleRightController(e)}}>
                            {this.state.isRightControllerShow?
                            <>
                                <ControllerBtnIcon><HiOutlineX size={28} /></ControllerBtnIcon>
                                <ControllerBtnIconLarge><HiOutlineX size={33} /></ControllerBtnIconLarge>
                            </>
                            :
                            <>
                                <ControllerBtnIcon><HiOutlineUserCircle size={28} /></ControllerBtnIcon>
                                <ControllerBtnIconLarge><HiOutlineUserCircle size={33} /></ControllerBtnIconLarge>
                            </>
                            }
                            </WidgetHeaderController>
                        </WidgetHeader>
                    </WidgetHeaderBox>
                    {this.state.isLoggedIn?
                        <WidgetNavigator isOpen={this.state.isLeftControllerShow} changePages={this.funcNavigatePage} navigationClicked={this.handleMenuController} userMenu={this.state.menu} />
                    :null}
                    {this.state.isLoggedIn?
                        <WidgetAccount isOpen={this.state.isRightControllerShow}
                            username={this.state.username}
                            fullname={this.state.fullname} level={this.state.level}
                            position={this.state.position}
                            company={this.state.company}
                            userProfile={this.state.user_profile} 
                            funcLoggedOut={this.funcLoggedOut}
                        />
                    :null}
                </WidgetHeaderContainer>
            )
        } else {
            return null;
        }
    }
}

export default Header;